import { render, staticRenderFns } from "./formBaseDocument.vue?vue&type=template&id=ff6e4e3c&"
import script from "./formBaseDocument.vue?vue&type=script&lang=js&"
export * from "./formBaseDocument.vue?vue&type=script&lang=js&"
import style0 from "./formBaseDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports